import { Injectable } from "@angular/core";
import { InviteModel } from "../../../common/models/invite/InviteModel";
import { ApiDataService } from "../ApiDataService";
import { firstValueFrom } from "rxjs";

@Injectable()
export class InviteDataService extends ApiDataService {
    cachedData: Promise<InviteModel>;

    constructor() {
        super("invites");
    }

    getItems(refresh?: boolean, id?: number, typeId?: number): Promise<InviteModel> {
        if (refresh) {
            this.cachedData = null;
        }
        if (!this.cachedData) {
            const url = `/${typeId}?objectID=${id}`;
            this.cachedData = firstValueFrom(this.get<InviteModel>(url));
        }
        return this.cachedData;
    }

    sendInvite(invites: InviteModel): Promise<Object> {
        const response = firstValueFrom(this.post(invites));

        return response;
    }
}
